<template>
    <div class="vx-row">
        <div class="vx-col xl:w-1/3 lg:w-1/2 w-full mb-6">
            <vx-card id="userDiv" class="vs-con-loading__container">
                <vs-checkbox class="mt-3" v-model="user.admin_user">{{ $t('UserAdmin') }}</vs-checkbox>
                <p class="mt-6">{{ $t('UserName') }}</p>
                <vs-input class="w-full" v-model="user.name"/>
                <p class="mt-6">{{ $t('UserEmail') }}</p>
                <vs-input class="w-full" v-model="user.email"/>
                <p class="mt-6">{{ $t('RFIDId') }}</p>
                <vs-input class="w-full" v-model="user.key_id"/>
                <p class="mt-6">{{ $t('AccessGroup') }}</p>
                <vs-select autocomplete class="w-full" v-model="user.access_group_id">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in groups" />
                </vs-select>
                <vs-divider/>
                <vs-button style="float: left" color="warning" icon-pack="feather" icon="icon-save" class="mb-3 mr-3" @click="saveUser">{{ $t('Save') }}</vs-button>
                <vs-button style="float: left" color="danger" icon-pack="feather" icon="icon-save" class="mb-3" @click="removeUser">{{ $t('Remove') }}</vs-button>

            </vx-card>
        </div>

        <div class="vx-col xl:w-2/3 lg:w-1/2 w-full">
            <access-table :data-u-r-l="`/api/management/v1/client_user/${this.$route.params.id}/access`"/>
        </div>


        <vs-divider/>
    </div>
</template>
<script>
    import AccessTable from '@/views/Access/AccessTable'
    export default {
        components: { AccessTable },
        data() {
            return {

                user: {
                    name: '',
                    email: '',
                    key_id: '',
                    access_group_id: '',
                    access_group_name: '',
                    admin_user: false
                },

                groups: []

            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#userDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get(`/api/management/v1/client_user/${this.$route.params.id}`)
                loadPromise.then(function(response) {
                    thisIns.user = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const terminalsPromise = this.$http.get('/api/management/v1/client_user_access_group/')
                terminalsPromise.then(function(response) {
                    thisIns.groups = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([loadPromise, terminalsPromise]).finally(function() {
                    thisIns.$vs.loading.close('#userDiv > .con-vs-loading')
                })
            },
            saveUser() {
                this.$vs.loading({
                    container: '#userDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const addPromise = this.$http.put(`/api/management/v1/client_user/${this.$route.params.id}`, {
                    name: this.user.name,
                    email: this.user.email,
                    key_id: this.user.key_id,
                    admin_user: this.user.admin_user,
                    web_access_allowed: false,
                    access_group_id: Number(this.user.access_group_id)
                })

                addPromise.then(function() {
                    thisIns.$printSuccess(thisIns.$t('UserSaved'))
                    thisIns.loadData()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#userDiv > .con-vs-loading')
                })
            },
            removeUser() {
                this.$vs.loading({
                    container: '#userDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const removePromise = this.$http.delete(`/api/management/v1/client_user/${this.$route.params.id}`)
                removePromise.then(function() {
                    thisIns.$printSuccess(thisIns.$t('UserRemoved'))
                    thisIns.$nextTick(() => {
                        thisIns.$router.push('/users')
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#userDiv > .con-vs-loading')
                })
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>
